//Imports
import {
	SERIES_COLLECTION,
	VIDEO_COLLECTION,
	LIKES_COLLECTION,
	SPEAKERS_COLLECTION,
	MEDIA_METADATA_COLLECTION,
	SEASON_COLLECTION
} from '../../../AppConstants/CollectionConstants';
import { SourceType, VideoType, ContentType, ExclusiveType } from '../../../AppConstants/TypeConstants';

// Firebase
import firebase, { firestore } from '../../../firebase/firebase';
const uniqid = require('uniqid');

const createSeason = async ({
	seriesId,
	seasonIndex,
	title,
	description,
	tags,
	speakers,
	detailsId,
	thumbnailUrl,
	featuredIndex,
	episodes,
	therapy,
	associationType,
	associationId,
	type
}) => {
	try {
		const seasonId = uniqid('season-');
		const metaDataId = uniqid('media-metadata-');

		// formatting tags and speakers
		tags = tags ? tags.map((t) => t.toLowerCase()) : [];
		speakers = speakers ? speakers : [];
		therapy = therapy ? therapy.map((t) => t.toLowerCase()) : [];

		let season = {
			title,
			description,
			id: seasonId,
			seriesId,
			type: type ? type : ExclusiveType.FREE,

			speakers: speakers || [],
			tags: [ ...tags, ...therapy ],

			likes: 0,
			views: 0,
			detailsId: detailsId || null,
			rating: 0,
			ratingsgiven: 0,
			featuredIndex: featuredIndex ? featuredIndex : -1,

			thumbnailUrl: thumbnailUrl || null,
			episodes: episodes && episodes.length ? episodes : [],

			timestamp: firebase.firestore.FieldValue.serverTimestamp()
		};

		let metaData = {
			id: metaDataId,
			targetId: seasonId,
			contentType: type ? type : ExclusiveType.FREE,
			mediaType: ContentType.SEASON,

			timestamp: firebase.firestore.FieldValue.serverTimestamp(),
			detailsId: detailsId || null,

			therapy: therapy || [],
			tags: [ ...tags, ...therapy ], //contains tags and therapy

			Thumbnails: {
				small: 'https://storage.googleapis.com/cipla-impact.appspot.com/impact2021/video/1.jpg',
				medium: 'https://storage.googleapis.com/cipla-impact.appspot.com/impact2021/video/2.jpg',
				large: 'https://storage.googleapis.com/cipla-impact.appspot.com/impact2021/video/3.jpg'
			},

			title: title,
			description: description,

			associationType: associationType || null,
			associationId: associationId || null
		};

		await firestore.runTransaction(async (transaction) => {
			let seriesRef = firestore.collection(SERIES_COLLECTION).doc(seriesId);
			let doc = await transaction.get(seriesRef);
			let seriesData = doc.data();

			if (!doc.exists) {
				let err = {
					code: 'NotValidId',
					message: 'No series Found'
				};
				throw err;
			}

			transaction.set(firestore.collection(SEASON_COLLECTION).doc(seasonId), season);
			transaction.set(firestore.collection(MEDIA_METADATA_COLLECTION).doc(metaDataId), metaData);

			// Update series
			let seasonslength = seriesData.seasons.length;

			if (seasonIndex !== null && seasonIndex !== undefined && seasonIndex < seasonslength) {
				seriesData.seasons.splice(seasonIndex, 0, {
					seasonNumber: seasonIndex + 1,
					seasonTitle: title,
					seasonId: seasonId
				});
			} else {
				seriesData.seasons.push({
					seasonNumber: seasonslength,
					seasonTitle: title,
					seasonId: seasonId
				});
			}

			transaction.update(seriesRef, {
				seasons: seriesData.seasons
			});
		});

		return seasonId;
	} catch (error) {
		console.log('Error :: ', error);
		throw error;
	}
};

const post = {
	createSeason
};

export default post;
